import { TarefasPage } from "./TarefasPage";

export default TarefasPage;
